module.exports = __webpack_public_path__ + "accessibility-good.a0ce1b035e5ecc978ab12c304c453634.hashedasset.png";